module.exports = " <div class=\"button-bar von-button-bar\" _v-32cf8735=\"\"> <a v-for=\"(index, tabItem) in tabItems\" class=\"{{ getButtonClass(index) }}\" @click=tabChanged(index) _v-32cf8735=\"\"> {{ tabItem }} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-32cf8735!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttonbar/index.vue
// module id = 257
// module chunks = 0